module.exports = __webpack_public_path__ + "img/tel_icon.e587e65e.png";